export const csrfToken = () =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''

export class ApiError extends Error {
  status: number
  body: unknown

  constructor(status: number, body: unknown, message: string) {
    super(message)
    this.status = status
    this.body = body
  }
}

const messageFrom = (body: unknown, status: number) => {
  if (body && typeof body === 'object') {
    const record = body as { error?: string; errors?: string[] }
    if (record.error) return record.error
    if (record.errors?.length) return record.errors.join(', ')
  }
  return `Request failed (${status})`
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    credentials: 'same-origin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...options.headers,
    },
  })

  const body = response.status === 204 ? null : await response.json().catch(() => null)

  if (!response.ok) throw new ApiError(response.status, body, messageFrom(body, response.status))

  return body as T
}

export const get = <T,>(path: string) => api<T>(path)

export const post = <T,>(path: string, data: unknown) =>
  api<T>(path, { method: 'POST', body: JSON.stringify(data) })

export const patch = <T,>(path: string, data: unknown) =>
  api<T>(path, { method: 'PATCH', body: JSON.stringify(data) })

export const destroy = <T,>(path: string) => api<T>(path, { method: 'DELETE' })
